// src/components/layout/NetworkStatus.jsx
import React from 'react';
import { WifiOff, Wifi, RefreshCw } from 'lucide-react';

const NetworkStatus = ({ isOnline, isSyncing }) => {
  if (isOnline && !isSyncing) {
    return null; // Don't show anything when online and not syncing
  }

  return (
    <div className={`
      fixed bottom-0 left-0 right-0 z-50 safe-area-inset-bottom
      ${isOnline 
        ? 'bg-blue-600 text-white' 
        : 'bg-red-600 text-white'
      }
    `}>
      <div className="flex items-center justify-center gap-2 px-4 py-2.5 sm:py-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          {isSyncing ? (
            <RefreshCw className="w-4 h-4 sm:w-5 sm:h-5 animate-spin" />
          ) : isOnline ? (
            <Wifi className="w-4 h-4 sm:w-5 sm:h-5" />
          ) : (
            <WifiOff className="w-4 h-4 sm:w-5 sm:h-5" />
          )}
        </div>

        {/* Message */}
        <span className="text-xs sm:text-sm font-medium text-center">
          {isSyncing
            ? 'Syncing data...'
            : isOnline
              ? 'Connected'
              : 'You are currently offline. Some features may be unavailable.'
          }
        </span>
      </div>

      {/* Progress bar for syncing */}
      {isSyncing && (
        <div className="h-0.5 bg-white/20">
          <div className="h-full bg-white/60 animate-pulse"></div>
        </div>
      )}
    </div>
  );
};

export default NetworkStatus;